import { css } from '@emotion/react';

export const typography = css`
  @font-face {
    font-family: 'Charlie Display';
    font-style: italic;
    font-weight: 900;
    src: url('/asset/font/charlie-display/Charlie_Display-Black_Italic.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Display';
    font-style: normal;
    font-weight: 900;
    src: url('/asset/font/charlie-display/Charlie_Display-Black.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Display';
    font-style: italic;
    font-weight: 700;
    src: url('/asset/font/charlie-display/Charlie_Display-Bold_Italic.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Display';
    font-style: normal;
    font-weight: 700;
    src: url('/asset/font/charlie-display/Charlie_Display-Bold.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Display';
    font-style: italic;
    font-weight: 300;
    src: url('/asset/font/charlie-display/Charlie_Display-Light_Italic.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Display';
    font-style: normal;
    font-weight: 300;
    src: url('/asset/font/charlie-display/Charlie_Display-Light.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Display';
    font-style: italic;
    font-weight: 400;
    src: url('/asset/font/charlie-display/Charlie_Display-Regular_Italic.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Display';
    font-style: normal;
    font-weight: 400;
    src: url('/asset/font/charlie-display/Charlie_Display-Regular.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Display';
    font-style: italic;
    font-weight: 600;
    src: url('/asset/font/charlie-display/Charlie_Display-Semibold_Italic.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Display';
    font-style: normal;
    font-weight: 600;
    src: url('/asset/font/charlie-display/Charlie_Display-Semibold.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Display';
    font-style: italic;
    font-weight: 100;
    src: url('/asset/font/charlie-display/Charlie_Display-Thin_Italic.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Display';
    font-style: normal;
    font-weight: 100;
    src: url('/asset/font/charlie-display/Charlie_Display-Thin.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Display';
    font-style: italic;
    font-weight: 800;
    src: url('/asset/font/charlie-display/Charlie_Display-Ultra_Italic.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Display';
    font-style: normal;
    font-weight: 800;
    src: url('/asset/font/charlie-display/Charlie_Display-Ultra.woff2')
      format('woff2');
  }

  @font-face {
    font-family: 'Charlie Text';
    font-style: italic;
    font-weight: 900;
    src: url('/asset/font/charlie-text/Charlie_Text-Black_Italic.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Text';
    font-style: normal;
    font-weight: 900;
    src: url('/asset/font/charlie-text/Charlie_Text-Black.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Text';
    font-style: italic;
    font-weight: 700;
    src: url('/asset/font/charlie-text/Charlie_Text-Bold_Italic.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Text';
    font-style: normal;
    font-weight: 700;
    src: url('/asset/font/charlie-text/Charlie_Text-Bold.woff2') format('woff2');
  }
  @font-face {
    font-family: 'Charlie Text';
    font-style: italic;
    font-weight: 300;
    src: url('/asset/font/charlie-text/Charlie_Text-Light_Italic.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Text';
    font-style: normal;
    font-weight: 300;
    src: url('/asset/font/charlie-text/Charlie_Text-Light.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Text';
    font-style: italic;
    font-weight: 400;
    src: url('/asset/font/charlie-text/Charlie_Text-Regular_Italic.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Text';
    font-style: normal;
    font-weight: 400;
    src: url('/asset/font/charlie-text/Charlie_Text-Regular.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Text';
    font-style: italic;
    font-weight: 600;
    src: url('/asset/font/charlie-text/Charlie_Text-Semibold_Italic.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Text';
    font-style: normal;
    font-weight: 600;
    src: url('/asset/font/charlie-text/Charlie_Text-Semibold.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Text';
    font-style: italic;
    font-weight: 100;
    src: url('/asset/font/charlie-text/Charlie_Text-Thin_Italic.woff2')
      format('woff2');
  }
  @font-face {
    font-family: 'Charlie Text';
    font-style: normal;
    font-weight: 100;
    src: url('/asset/font/charlie-text/Charlie_Text-Thin.woff2') format('woff2');
  }

  :root {
    --atlassian-recommended-system-fonts: -apple-system, BlinkMacSystemFont,
      'Segoe UI', Roboto, Oxygen, Ubuntu, 'Fira Sans', 'Droid Sans',
      'Helvetica Neue', sans-serif;
    --bxp-charlie-display-font-family: 'Charlie Display',
      var(--atlassian-recommended-system-fonts);
    --bxp-charlie-text-font-family: 'Charlie Text',
      var(--atlassian-recommended-system-fonts);
  }
`;
